function getFilenameWithoutExtension(filename: string): string {
    return filename.replace(/\.([^.]*)$/g, '');
}

export default getFilenameWithoutExtension;
